function parseDateBrasil(dateStr) {
  if (!dateStr) return null;
  return new Date(dateStr + 'T00:00:00-03:00');
}
function getDataCriacaoTarefa(tarefa) {
  return tarefa.data_criacao || tarefa.criado_em || tarefa.dataCriacao || null;
}
function dataString(date) {
  if (!date) return '';
  if (typeof date === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    const [dia, mes, ano] = date.split('/');
    return `${ano}-${mes}-${dia}`;
  }
  if (typeof date === 'string') return date.slice(0, 10);
  const dt = new Date(date.getTime() - (date.getTimezoneOffset() - 180) * 60000);
  return dt.toISOString().slice(0, 10);
}
function getCorBolinhaStatusLead(
  lead,
  tarefas = [],
  interacoes = [],
  dataHoje = new Date()
) {
  // LOG SNIPER — diagnóstico
  console.log('[SNIPER] LEAD:', lead);
  console.log('[SNIPER] TAREFAS:', tarefas);
  console.log('[SNIPER] INTERACOES:', interacoes);

  // Blindagem: filtra tarefas só do lead e empresa/loja (use empresaAtiva.id!)
  tarefas = tarefas.filter(
    t =>
      String(t.lead_id || t.id_lead) === String(lead.id) &&
      String(t.empresa_id || t.loja_id) === String(lead.empresa_id || lead.loja_id)
  );
  console.log('[SNIPER] TAREFAS FILTRADAS:', tarefas);

  const lower = str => (str || '').toString().trim().toLowerCase();
  const statusLead = lower(lead.status_lead || lead.status);
  const statusNegociacao = lower(lead.status_negociacao);
  const dataCriacaoLead = lead.data_criacao
    ? parseDateBrasil(lead.data_criacao)
    : lead.data_lead
    ? parseDateBrasil(lead.data_lead)
    : lead.data_lancamento
    ? parseDateBrasil(lead.data_lancamento)
    : null;
  const hojeString = dataString(dataHoje);
  const emojiMap = {
    preto: '⚫️',
    verde: '🏆',
    azul: '🔵',
    vermelho: '🔴',
    cinza: '⚪️',
    amarelo: '🟡',
    roxo: '🟣',
    pink: '🟢'
  };

  // --- PRETO: Perdido/Migrou
  if (
    statusNegociacao === 'perdido' ||
    statusNegociacao === 'migrou para concorrência' ||
    statusLead === 'perdido' ||
    statusLead === 'migrou para concorrência'
  ) return { cor: 'preto', emoji: emojiMap.preto, bordaVerde: false };

  // --- VERDE: Fechado
  if (statusNegociacao === 'fechado')
    return { cor: 'verde', emoji: emojiMap.verde, bordaVerde: false };

  // --- FECHADO PARCIAL: última tarefa pendente + vencida = vermelho, senão resto
  if (statusNegociacao === 'fechado parcial') {
    const ultimaTarefa = tarefas
      .filter(t => getDataCriacaoTarefa(t))
      .sort((a, b) => new Date(getDataCriacaoTarefa(b)) - new Date(getDataCriacaoTarefa(a)))[0];
    console.log('[SNIPER] ULTIMA TAREFA:', ultimaTarefa);
    if (ultimaTarefa) {
      const pendente = lower(ultimaTarefa.status) !== 'concluído' && lower(ultimaTarefa.status) !== 'concluido';
      const vencida = ultimaTarefa.data_vencimento && dataString(ultimaTarefa.data_vencimento) < hojeString;
      console.log('[SNIPER] pendente:', pendente, 'vencida:', vencida, 'data_vencimento:', ultimaTarefa.data_vencimento, 'hoje:', hojeString);
      if (pendente && vencida) return { cor: 'vermelho', emoji: emojiMap.vermelho, bordaVerde: false };
    }
    const tarefasFuturas = tarefas.filter(t => {
      const pendente = lower(t.status) !== 'concluído' && lower(t.status) !== 'concluido';
      let futuro = false;
      if (t.data_vencimento) futuro = dataString(t.data_vencimento) >= hojeString;
      return pendente && futuro;
    });
    console.log('[SNIPER] TAREFAS FUTURAS:', tarefasFuturas);
    if (tarefasFuturas.length > 0) return { cor: 'pink', emoji: emojiMap.pink, bordaVerde: false };

    const dezDiasAtras = new Date(dataHoje);
    dezDiasAtras.setDate(dezDiasAtras.getDate() - 10);
    const dezDiasAtrasString = dataString(dezDiasAtras);
    const teveInteracaoRecente = interacoes.some(inter => {
      if (!inter.data) return false;
      return dataString(inter.data) >= dezDiasAtrasString;
    });
    console.log('[SNIPER] TEVE INTERACAO RECENTE:', teveInteracaoRecente);
    if (teveInteracaoRecente) return { cor: 'pink', emoji: emojiMap.pink, bordaVerde: false };
    else return { cor: 'vermelho', emoji: emojiMap.vermelho, bordaVerde: false };
  }

  // --- VERDE: Fechado, Compareceu, todas tarefas concluídas, tem interação
  const todasTarefasConcluidas =
    tarefas.length > 0 &&
    tarefas.every(
      t => lower(t.status) === 'concluído' || lower(t.status) === 'concluido'
    );
  const temInteracao = Array.isArray(interacoes) && interacoes.length > 0;
  if (
    statusNegociacao === 'fechado' &&
    statusLead === 'compareceu' &&
    todasTarefasConcluidas &&
    temInteracao
  )
    return { cor: 'verde', emoji: emojiMap.verde, bordaVerde: false };

  // --- REGRA DE ÚLTIMA TAREFA CRIADA
  let ultimaTarefa = null;
  if (tarefas.length > 0) {
    ultimaTarefa = tarefas
      .filter(t => getDataCriacaoTarefa(t))
      .sort((a, b) => new Date(getDataCriacaoTarefa(b)) - new Date(getDataCriacaoTarefa(a)))[0];
  }
  console.log('[SNIPER] ULTIMA TAREFA (geral):', ultimaTarefa);

  // --- VERMELHA: última pendente + vencida
  if (ultimaTarefa) {
    const pendente = lower(ultimaTarefa.status) !== 'concluído' && lower(ultimaTarefa.status) !== 'concluido';
    const vencString = dataString(ultimaTarefa.data_vencimento);
    console.log('[SNIPER] pendente:', pendente, 'vencida:', vencString < hojeString, 'data_vencimento:', ultimaTarefa.data_vencimento, 'hoje:', hojeString);
    if (pendente && vencString < hojeString) return { cor: 'vermelho', emoji: emojiMap.vermelho, bordaVerde: false };
  }

  // --- VERMELHA: última concluída mas negociação não fechada (sem tarefa futura pendente)
  if (
    ultimaTarefa &&
    (lower(ultimaTarefa.status) === 'concluído' || lower(ultimaTarefa.status) === 'concluido') &&
    statusNegociacao !== 'fechado'
  ) {
    const existeTarefaPendenteFutura = tarefas.some(t => {
      const pendente = lower(t.status) !== 'concluído' && lower(t.status) !== 'concluido';
      return pendente && dataString(t.data_vencimento) >= hojeString;
    });
    console.log('[SNIPER] existeTarefaPendenteFutura:', existeTarefaPendenteFutura);
    if (!existeTarefaPendenteFutura) return { cor: 'vermelho', emoji: emojiMap.vermelho, bordaVerde: false };
  }

  // --- AZUL: Negociando, tarefa futura, tem interação
  const statusNegociacaoAzul = ['negociando'];
  const tarefasFuturas = tarefas.filter(
    t => {
      const pendente = lower(t.status) !== 'concluído' && lower(t.status) !== 'concluido';
      let vencimentoFuturo = false;
      if (t.data_vencimento) vencimentoFuturo = dataString(t.data_vencimento) >= hojeString;
      return pendente && vencimentoFuturo;
    }
  );
  console.log('[SNIPER] TAREFAS FUTURAS (geral):', tarefasFuturas);

  if (
    statusNegociacaoAzul.includes(statusNegociacao) &&
    tarefasFuturas.length > 0 &&
    temInteracao
  )
    return { cor: 'azul', emoji: emojiMap.azul, bordaVerde: false };

  // --- AMARELA: pendente, tarefa futura (regra especial)
  if (
    statusNegociacao === 'pendente' &&
    tarefasFuturas.length > 0
  )
    return { cor: 'amarelo', emoji: emojiMap.amarelo, bordaVerde: false };

  // --- AMARELA (prospectando)
  const statusProspec = ['prospecção', 'prospectando', 'prospeccao', 'prospeitando'];
  const leadNovo = (
    tarefas.length === 0 &&
    dataCriacaoLead &&
    (dataString(dataHoje) === dataString(dataCriacaoLead) ||
      (new Date(dataString(dataHoje)) - new Date(dataString(dataCriacaoLead))) / 86400000 < 2)
  );
  if (
    statusProspec.includes(statusNegociacao) &&
    !leadNovo
  )
    return { cor: 'amarelo', emoji: emojiMap.amarelo, bordaVerde: false };

  // --- VERMELHA: Sem tarefa, lead criada há 2 dias ou mais
  if (
    tarefas.length === 0 &&
    dataCriacaoLead &&
    (new Date(dataString(dataHoje)) - new Date(dataString(dataCriacaoLead))) / 86400000 >= 2
  )
    return { cor: 'vermelho', emoji: emojiMap.vermelho, bordaVerde: false };

  // --- CINZA: Sem tarefa, lead criada há menos de 2 dias
  if (
    tarefas.length === 0 &&
    dataCriacaoLead &&
    (new Date(dataString(dataHoje)) - new Date(dataString(dataCriacaoLead))) / 86400000 < 2
  )
    return { cor: 'cinza', emoji: emojiMap.cinza, bordaVerde: false };

  // --- AMARELA: Sem interação, tarefa futura, status negociação diferente de Fechado/Perdido
  if (
    !temInteracao &&
    tarefasFuturas.length > 0 &&
    statusNegociacao !== 'fechado' &&
    statusNegociacao !== 'perdido'
  )
    return { cor: 'amarelo', emoji: emojiMap.amarelo, bordaVerde: false };

  // --- ROXO: fallback
  return { cor: 'roxo', emoji: emojiMap.roxo, bordaVerde: false };
}

export default getCorBolinhaStatusLead;